export default __webpack_public_path__ + "static/media/mb-check.99342d00.svg";